import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FormRegistroUsuario from "../components/RegistroUsuarios/FormRegistroUsuario.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RegistroUsuarioView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRegistroUsuario))
}
}

})